document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-showcase-slider__swiper').forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 2.8,
      spaceBetween: 8,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 8,
        },
        480: {
          slidesPerView: 1.8,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        1025: {
          slidesPerView: 2.8,
          spaceBetween: 8,
        },
      },
    });
  });
});
